var map = {
	"./apk.png": "c10a",
	"./docx.png": "3eae",
	"./html.png": "72ad",
	"./ios.png": "e44c",
	"./mp3.png": "1e8b",
	"./mp4.png": "f131",
	"./pdf.png": "9b6e",
	"./ppt.png": "b065",
	"./qt.png": "d0ba",
	"./txt.png": "a680",
	"./wjj.png": "e86b",
	"./xlsx.png": "475e",
	"./zip.png": "b35b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35f7";